module.exports = __webpack_public_path__ + "static/media/calendar_daily.c43ffaf0.svg";